/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react'
import { compose } from 'lodash/fp'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import Flex from 'typescript-styled-flex'
import { formValues } from 'redux-form'
import Scrollbars from 'react-custom-scrollbars'
import { copyAddressValues } from '../../../actions/bookingCalendar/reservationModal/copyAddressValues'
import ExpandableFormSection from '../../../components/Form/Sections/ExpandableFormSection'
import { CountrySelect, TextInput } from '../../../components/FormBuilder'
import Button from '../../../components/Template/Button'
import { is } from '../../../components/MediaQuery'
import { IWithSize } from '../../BookingCalendar/Calendar/Calendar'
import { ClientSearch } from './Components'
import { PopoveredIcon2 } from '../../../components/PopoveredIcon/PopoveredIcon'
import UpgradePremiumBlockScreenModal from '../../UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'
import { useMediaQuery, useTheme } from '@material-ui/core'

function GuestInfo({
  disabled = false,
  formKey,
  guestLabel,
  size = 1,
  setPhone,
  expanded = false,
  withBorder = true,
  canCopy = false,
  enableSearch = false,
  copyGuestAddressInfo,
  parseName,
  guestScroll,
  t,
  ...rest
}: IGuestInfoProps &
  IGuestInfoDispatch &
  WithTranslation &
  IWithSize & { setPhone?: (e) => void }) {
  const isDesktop = is.desktop()

  const ref = useRef(null as HTMLDivElement)
  const [canOpen, setCanOpen] = useState(false)
  const [open, setOpen] = React.useState(false)
  const theme2 = useTheme()
  const isMobile = useMediaQuery(theme2.breakpoints.down('sm'))
  const [isModalOpened, setIsModalOpened] = useState(false)
  const [popoverAnchor, setPopoverAnchor] = useState(null)

  const handlePopoverOpen = event => {
    if (isMobile) {
      setIsModalOpened(true)
    } else {
      event.preventDefault()
      event.stopPropagation()
      setPopoverAnchor(event.currentTarget)
    }
  }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setPopoverAnchor(null)
  }

  useEffect(() => {
    setTimeout(() => setCanOpen(true), 1000)
  }, [])

  useEffect(() => {
    if (canOpen && rest['guest.name'] && rest['guest.name'].length <= 3) {
      setOpen(true)
    }
    if (!rest['guest.name'] || rest['guest.name'].length === 0) {
      setOpen(false)
    }
  }, [rest['guest.name']])

  useEffect(() => {
    if (
      guestScroll &&
      guestScroll.current &&
      'view' in (guestScroll.current as any)
    ) {
      ;(guestScroll.current as any).view.addEventListener(
        'scroll',
        hideWhenInputNotvisible,
      )
    }
    return () => {
      if (
        guestScroll &&
        guestScroll.current &&
        'view' in (guestScroll.current as any)
      ) {
        ;(guestScroll.current as any).view.removeEventListener(
          'scroll',
          hideWhenInputNotvisible,
        )
      }
    }
  })

  function onClick() {
    setOpen(!open)
  }

  function onClose() {
    setOpen(false)
  }

  function isVisible(elem: any) {
    const style = getComputedStyle(elem)
    if (style.display === 'none') return false
    if (style.visibility !== 'visible') return false
    if (Number(style.opacity) < 0.1) return false
    if (
      elem.offsetWidth +
        elem.offsetHeight +
        elem.getBoundingClientRect().height +
        elem.getBoundingClientRect().width ===
      0
    ) {
      return false
    }
    const elemCenter = {
      x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
      y: elem.getBoundingClientRect().top + elem.offsetHeight / 2,
    }
    if (elemCenter.x < 0) return false
    if (
      elemCenter.x > (document.documentElement.clientWidth || window.innerWidth)
    )
      return false
    if (elemCenter.y < 0) return false
    if (
      elemCenter.y >
      (document.documentElement.clientHeight || window.innerHeight)
    )
      return false
    let pointContainer: any = document.elementFromPoint(
      elemCenter.x,
      elemCenter.y,
    )
    do {
      if (pointContainer === elem) return true
    } while ((pointContainer = pointContainer.parentNode))
    return false
  }

  function hideWhenInputNotvisible() {
    if (!isVisible(ref.current)) {
      onClose()
    }
  }

  useEffect(() => {
    document.addEventListener('wheel', hideWhenInputNotvisible)
    document.addEventListener('touchmove', hideWhenInputNotvisible)
    return () => {
      document.removeEventListener('wheel', hideWhenInputNotvisible)
      document.removeEventListener('touchmove', hideWhenInputNotvisible)
    }
  })

  return (
    <ExpandableFormSection
      size={size}
      withBorder={withBorder}
      expanded={expanded}
      initialInput={
        <>
          <TextInput.ReduxField
            size={size}
            autocomplete={'off'}
            disabled={disabled}
            withPopoverIcon={disabled}
            name={`${formKey}.name`}
            isSmallReservation={true}
            placeholder={`${t('reservation_person_hint')} (${guestLabel})`}
            width={'100%'}
            anchorRef={ref}
            onClick={onClick}
            onBlur={parseName}
          />
          {enableSearch && (
            <ClientSearch
              setPhone={setPhone}
              closePopper={onClose}
              open={open}
              anchor={ref}
            />
          )}
        </>
      }
    >
      <Flex column={true} full={true}>
        <TextInput.ReduxField
          size={size}
          disabled={disabled}
          withPopoverIcon={disabled}
          labelStyle={{ display: 'flex', gap: '8px' }}
          label={t('reservation_person_street')}
          name={`${formKey}.street`}
          width={'100%'}
          wrapperStyle={{ marginTop: `${10 * size}px` }}
          isSmallReservation={true}
        />
        <Flex
          style={{ marginTop: `${10 * size}px` }}
          row={true}
          alignEnd={true}
          contentSpaceBetween={true}
        >
          <TextInput.ReduxField
            size={size}
            disabled={disabled}
            withPopoverIcon={disabled}
            labelStyle={{ display: 'flex', gap: '8px' }}
            label={t('reservation_person_house')}
            name={`${formKey}.houseNumber`}
            style={{ width: !isDesktop ? '100%' : 'auto' }}
            wrapperStyle={{ marginRight: `${20 * size}px`, zIndex: 10 }}
            isSmallReservation={true}
          />
          <TextInput.ReduxField
            size={size}
            disabled={disabled}
            withPopoverIcon={disabled}
            labelStyle={{ display: 'flex', gap: '8px' }}
            label={t('reservation_person_apartment')}
            style={{ maxWidth: !isDesktop ? 'auto' : 'none' }}
            name={`${formKey}.apartmentNumber`}
            isSmallReservation={true}
          />
        </Flex>
        <TextInput.ReduxField
          size={size}
          disabled={disabled}
          withPopoverIcon={disabled}
          labelStyle={{ display: 'flex', gap: '8px' }}
          label={t('reservation_person_town')}
          width={'100%'}
          name={`${formKey}.city`}
          isSmallReservation={true}
          wrapperStyle={{ margin: `${10 * size}px 0px` }}
        />
        <TextInput.ReduxField
          size={size}
          disabled={disabled}
          withPopoverIcon={disabled}
          labelStyle={{ display: 'flex', gap: '8px' }}
          label={t('reservation_person_post_code')}
          width={'100%'}
          name={`${formKey}.postCode`}
          isSmallReservation={true}
        />
        <CountrySelect
          size={size}
          disabled={disabled}
          withPopoverIcon={disabled}
          labelStyle={{ display: 'flex', gap: '8px' }}
          name={`${formKey}.country`}
          label={t('profile_country')}
          width={'100%'}
          placeholder={t('select')}
          noOptionsMessage={t('search_not_found')}
          countryValue={'code'}
          isSearchable={true}
          wrapperStyle={{ margin: `${10 * size}px 0px` }}
        />
        {canCopy && (
          <Button
            size={size}
            disabled={disabled}
            onClick={disabled ? handlePopoverOpen :() => copyGuestAddressInfo(formKey)}
            primary={true}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginTop: `${1.5 * size}em`,
            }}
          >
            {disabled && <PopoveredIcon2
              variant={'white'}
              anchorEl={popoverAnchor}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
            />}
            <span> {t('identical_address_details')}</span>
          </Button>
        )}
        <TextInput.ReduxField
          size={size}
          disabled={disabled}
          label={t('reservation_person_passport')}
          withPopoverIcon={disabled}
          labelStyle={{ display: 'flex', gap: '8px' }}
          width={'100%'}
          name={`${formKey}.passport`}
          isSmallReservation={true}
          wrapperStyle={{ margin: `${10 * size}px 0px` }}
        />
        <TextInput.ReduxField
          size={size}
          withPopoverIcon={disabled}
          labelStyle={{ display: 'flex', gap: '8px' }}
          disabled={disabled}
          label={t('reservation_person_identity_card')}
          width={'100%'}
          name={`${formKey}.idCard`}
          isSmallReservation={true}
        />
      </Flex>
      {isMobile && <UpgradePremiumBlockScreenModal
        open={isModalOpened}
        close={() => setIsModalOpened(false)}
      />}
    </ExpandableFormSection>
  )
}

export interface IGuestInfoProps {
  formKey: string
  guestLabel: string
  withBorder?: boolean
  canCopy?: boolean
  disabled?: boolean
  expanded?: boolean
  size?: number
  parseName?: any
  enableSearch?: boolean
  guestScroll?: React.RefObject<Scrollbars>
}

export interface IGuestInfoDispatch {
  copyGuestAddressInfo: (formKey: string) => void
}

const mapDispatchToProps = formName => (
  dispatch: Dispatch,
): IGuestInfoDispatch => ({
  copyGuestAddressInfo: formKey =>
    dispatch(copyAddressValues(formKey, formName)),
})

export const withCopyGuestFields = formName =>
  connect(
    null,
    mapDispatchToProps(formName),
  )

const GuestInfoCreate: React.ComponentType<
  IGuestInfoProps & { setPhone?: (e) => void }
> = compose(
  withCopyGuestFields('create_reservation'),
  withTranslation(),
)(React.memo(formValues<any>('guest.name')(GuestInfo)))

const GuestInfoUpdate: React.ComponentType<
  IGuestInfoProps & { setPhone?: (e) => void }
> = compose(
  withCopyGuestFields('update_reservation'),
  withTranslation(),
)(React.memo(formValues<any>('guest.name')(GuestInfo)))

export { GuestInfoCreate, GuestInfoUpdate }
